'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface NavLinkProps {
  href: string
  label: string
}

export const NavLink = ({ href, label }: NavLinkProps) => {
  const pathname = usePathname()
  const isActive = pathname === href

  return (
    <Link
      href={href}
      aria-label={label}
      className={`whitespace-nowrap rounded-xl px-3 py-2 text-base font-medium leading-6 transition-colors 
        ${
          isActive
            ? 'border-brand-primary-rest bg-brand-primary-light-10 text-brand-primary-rest hover:bg-brand-primary-light-10'
            : 'text-neutral-primary hover:bg-neutral-10'
        }`}
    >
      {label}
    </Link>
  )
}
